/* Theme JavaScript: drawers, modals, carousels, cart, product, search, filters, wishlist, newsletter */
(function () {
  'use strict';

  var T = window.theme || { routes: {}, strings: {} };
  var R = T.routes || {};
  var S = T.strings || {};
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function esc(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }
  function debounce(fn, ms) {
    var t;
    return function () {
      var a = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, a); }, ms);
    };
  }
  function store(key, val) {
    try {
      if (val === undefined) return window.localStorage.getItem(key);
      window.localStorage.setItem(key, val);
    } catch (e) { /* storage unavailable */ }
    return null;
  }
  function imgUrl(url, width) {
    if (!url) return '';
    try {
      var u = new URL(url, window.location.origin);
      u.searchParams.set('width', width);
      return u.toString();
    } catch (e) { return url; }
  }

  /* ---------- Money ---------- */
  function currencyRate() {
    var r = window.Shopify && window.Shopify.currency && parseFloat(window.Shopify.currency.rate);
    return r > 0 ? r : 1;
  }
  function formatMoney(cents) {
    var fmt = T.moneyFormat || '{{amount}}';
    if (typeof cents === 'string') cents = cents.replace('.', '');
    if (T.currency && T.shopCurrency && T.currency !== T.shopCurrency && window.Intl && Intl.NumberFormat) {
      try {
        return new Intl.NumberFormat(T.locale || undefined, { style: 'currency', currency: T.currency }).format(Number(cents) / 100);
      } catch (e) { /* fall back to the shop money format */ }
    }
    function withDelims(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return '0';
      var n = (number / 100).toFixed(precision);
      var parts = n.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, name) {
      switch (name) {
        case 'amount': return withDelims(cents, 2);
        case 'amount_no_decimals': return withDelims(cents, 0);
        case 'amount_with_comma_separator': return withDelims(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return withDelims(cents, 2, "'", '.');
        case 'amount_no_decimals_with_space_separator': return withDelims(cents, 0, ' ');
        case 'amount_with_space_separator': return withDelims(cents, 2, ' ', ',');
        case 'amount_with_period_and_space_separator': return withDelims(cents, 2, ' ', '.');
        default: return withDelims(cents, 2);
      }
    });
  }

  /* ---------- Focus helpers ---------- */
  var focusable = 'a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
  var lastFocus = null;
  function trapFocus(container, e) {
    if (e.key !== 'Tab') return;
    var items = $$(focusable, container).filter(function (el) { return el.offsetParent !== null; });
    if (!items.length) return;
    var first = items[0], last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  /* ---------- Drawers ---------- */
  var overlay = $('#DrawerOverlay');
  function lockScroll(lock) { document.body.style.overflow = lock ? 'hidden' : ''; }
  function openDrawers() { return $$('.drawer.is-open, .search-drawer.is-open'); }

  function openDrawer(id, trigger) {
    var d = document.getElementById(id);
    if (!d) return false;
    closeDrawers(true);
    lastFocus = trigger || document.activeElement;
    d.hidden = false;
    if (overlay) overlay.hidden = false;
    requestAnimationFrame(function () {
      d.classList.add('is-open');
      if (overlay) overlay.classList.add('is-visible');
      var target = $('input[type="search"], [autofocus]', d) || $(focusable, d);
      if (target) setTimeout(function () { target.focus(); }, 60);
    });
    lockScroll(true);
    document.dispatchEvent(new CustomEvent('drawer:open', { detail: { id: id } }));
    return true;
  }
  function closeDrawers(keepScroll) {
    openDrawers().forEach(function (d) {
      d.classList.remove('is-open');
      setTimeout(function () { if (!d.classList.contains('is-open')) d.hidden = true; }, 320);
    });
    if (overlay) {
      overlay.classList.remove('is-visible');
      setTimeout(function () { if (!overlay.classList.contains('is-visible')) overlay.hidden = true; }, 320);
    }
    if (!keepScroll) {
      lockScroll(false);
      if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) { /* noop */ } }
    }
  }

  /* ---------- Modals ---------- */
  function openModal(id, trigger) {
    var m = document.getElementById(id);
    if (!m) return;
    lastFocus = trigger || document.activeElement;
    m.hidden = false;
    requestAnimationFrame(function () { m.classList.add('is-open'); });
    lockScroll(true);
    var f = $(focusable, m);
    if (f) setTimeout(function () { f.focus(); }, 60);
  }
  function closeModals() {
    var any = false;
    $$('.modal.is-open').forEach(function (m) {
      any = true;
      m.classList.remove('is-open');
      m.hidden = true;
    });
    if (any && !openDrawers().length) {
      lockScroll(false);
      if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) { /* noop */ } }
    }
  }

  document.addEventListener('click', function (e) {
    var od = e.target.closest('[data-open-drawer]');
    if (od) { e.preventDefault(); openDrawer(od.getAttribute('data-open-drawer'), od); return; }
    if (e.target.closest('[data-close-drawer]') || e.target === overlay) { closeDrawers(); return; }
    var om = e.target.closest('[data-open-modal]');
    if (om) { e.preventDefault(); openModal(om.getAttribute('data-open-modal'), om); return; }
    if (e.target.closest('[data-close-modal]') || (e.target.classList && e.target.classList.contains('modal') && e.target.id !== 'PromoPopup')) {
      closeModals();
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeDrawers(); closeModals(); }
    var open = $('.drawer.is-open, .search-drawer.is-open, .modal.is-open');
    if (open) trapFocus(open, e);
  });

  /* ---------- Sticky header ---------- */
  var header = $('.site-header');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 40); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Section initialisers (re-run in the theme editor) ---------- */
  function initAnnouncement(root) {
    var bar = $('.announcement-bar', root);
    if (!bar || bar.__init) return;
    bar.__init = true;
    var msgs = $$('.announcement-bar__msg', bar);
    if (!msgs.length) return;
    var i = 0;
    msgs[0].classList.add('is-active');
    if (msgs.length < 2 || reduceMotion) return;
    var speed = (parseInt(bar.getAttribute('data-speed') || '5', 10) || 5) * 1000;
    var annTimer = setInterval(function () {
      if (!bar.isConnected) { clearInterval(annTimer); return; }
      msgs[i].classList.remove('is-active');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-active');
    }, speed);
  }

  function initHero(hero) {
    if (hero.__init) return;
    hero.__init = true;
    var slides = $$('.hero__slide', hero);
    var dotsWrap = $('.hero__dots', hero);
    if (!slides.length) return;
    var cur = 0, timer = null;
    slides[0].classList.add('is-active');
    if (slides.length < 2) return;
    var dots = [];
    if (dotsWrap) {
      slides.forEach(function (s, idx) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'hero__dot' + (idx === 0 ? ' is-active' : '');
        b.setAttribute('role', 'tab');
        b.setAttribute('aria-label', s.getAttribute('aria-label') || String(idx + 1));
        b.addEventListener('click', function () { go(idx); restart(); });
        dotsWrap.appendChild(b);
        dots.push(b);
      });
    }
    function go(idx) {
      slides[cur].classList.remove('is-active');
      if (dots[cur]) dots[cur].classList.remove('is-active');
      cur = (idx + slides.length) % slides.length;
      slides[cur].classList.add('is-active');
      if (dots[cur]) dots[cur].classList.add('is-active');
    }
    var auto = hero.getAttribute('data-autoplay') === 'true' && !reduceMotion;
    var sp = parseInt(hero.getAttribute('data-speed') || '6', 10) || 6;
    var delay = sp > 100 ? sp : sp * 1000;
    function stop() { clearInterval(timer); timer = null; }
    function restart() { stop(); if (auto) timer = setInterval(function () { if (!hero.isConnected) { stop(); return; } go(cur + 1); }, delay); }
    hero.addEventListener('mouseenter', stop);
    hero.addEventListener('mouseleave', restart);
    hero.addEventListener('focusin', stop);
    hero.addEventListener('focusout', restart);
    hero.addEventListener('shopify:block:select', function (e) {
      var idx = slides.indexOf(e.target);
      if (idx > -1) { stop(); go(idx); }
    });
    hero.addEventListener('shopify:block:deselect', restart);
    restart();
  }

  function initCountdown(el) {
    if (el.__init) return;
    el.__init = true;
    var end = new Date(el.getAttribute('data-countdown')).getTime();
    if (isNaN(end)) return;
    var dEl = $('[data-cd-d]', el), hEl = $('[data-cd-h]', el), mEl = $('[data-cd-m]', el), sEl = $('[data-cd-s]', el);
    function pad(n) { return String(n).padStart(2, '0'); }
    function tick() {
      var diff = Math.max(0, end - Date.now());
      var d = Math.floor(diff / 864e5); diff -= d * 864e5;
      var h = Math.floor(diff / 36e5); diff -= h * 36e5;
      var m = Math.floor(diff / 6e4); diff -= m * 6e4;
      var s = Math.floor(diff / 1e3);
      if (dEl) dEl.textContent = pad(d);
      if (hEl) hEl.textContent = pad(h);
      if (mEl) mEl.textContent = pad(m);
      if (sEl) sEl.textContent = pad(s);
    }
    tick();
    var cdTimer = setInterval(function () {
      if (!el.isConnected) { clearInterval(cdTimer); return; }
      tick();
    }, 1000);
  }

  function initVideo(wrap) {
    if (wrap.__init) return;
    wrap.__init = true;
    var btn = $('[data-video-play]', wrap), tpl = $('[data-video-template]', wrap);
    if (!btn || !tpl) return;
    btn.addEventListener('click', function () {
      var node = tpl.content.cloneNode(true);
      var iframe = node.querySelector('iframe');
      if (iframe) {
        var src = iframe.getAttribute('src') || '';
        iframe.setAttribute('src', src + (src.indexOf('?') > -1 ? '&' : '?') + 'autoplay=1');
        iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; fullscreen');
      }
      btn.remove();
      wrap.appendChild(node);
      if (iframe) iframe.focus();
    });
  }

  function initReveal(root) {
    var els = $$('[data-reveal]:not(.is-revealed)', root);
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || reduceMotion || T.designMode) {
      els.forEach(function (el) { el.classList.add('is-revealed'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-revealed'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initAccordions(root) {
    $$('.product-acc__btn', root).forEach(function (b) {
      if (b.__init) return;
      b.__init = true;
      b.addEventListener('click', function () {
        var item = b.closest('.product-acc__item');
        var panel = $('.product-acc__panel', item);
        var open = item.classList.toggle('is-open');
        b.setAttribute('aria-expanded', open ? 'true' : 'false');
        panel.style.maxHeight = open ? panel.scrollHeight + 'px' : '0px';
      });
    });
  }

  function initAll(root) {
    root = root || document;
    initAnnouncement(root);
    $$('[data-hero]', root).forEach(initHero);
    $$('[data-countdown]', root).forEach(initCountdown);
    $$('[data-video]', root).forEach(initVideo);
    initAccordions(root);
    initReveal(root);
    initWishlistButtons(root);
    initWishlistPage(root);
    initProductSections(root);
    initCartPage(root);
    initCartPageShipping(root);
    initFacets(root);
    initNewsletters(root);
    initRecentlyViewed(root);
    initDelivery(root);
    initLoadMore(root);
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });

  /* ---------- Carousels (delegated, works for dynamic content) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-carousel-prev], [data-carousel-next]');
    if (!btn) return;
    var car = btn.closest('[data-carousel]');
    var vp = car && $('.carousel__viewport', car);
    if (!vp) return;
    var item = $('.carousel__item', vp);
    var gap = parseInt(window.getComputedStyle(vp).columnGap || window.getComputedStyle(vp).gap || '16', 10) || 16;
    var step = (item ? item.getBoundingClientRect().width + gap : vp.clientWidth * 0.8) * 2;
    var dir = btn.hasAttribute('data-carousel-prev') ? -1 : 1;
    if (document.documentElement.dir === 'rtl') dir = -dir;
    vp.scrollBy({ left: dir * step, behavior: reduceMotion ? 'auto' : 'smooth' });
  });

  /* ---------- Wishlist (localStorage, by product handle) ---------- */
  var WKEY = 'theme_wishlist';
  function getW() { try { return JSON.parse(store(WKEY) || '[]'); } catch (e) { return []; } }
  function setW(v) { store(WKEY, JSON.stringify(v)); }
  function syncW(root) {
    var w = getW();
    $$('[data-wishlist]', root).forEach(function (b) {
      var on = w.indexOf(b.getAttribute('data-wishlist')) > -1;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  function initWishlistButtons(root) { syncW(root); }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-wishlist]');
    if (!b) return;
    e.preventDefault();
    var id = b.getAttribute('data-wishlist');
    var w = getW();
    w = w.indexOf(id) > -1 ? w.filter(function (x) { return x !== id; }) : w.concat(id);
    setW(w);
    syncW(document);
    var grid = $('[data-wishlist-grid]');
    if (grid && b.closest('[data-wishlist-grid]')) initWishlistPage(document, true);
  });

  function wishlistCard(p, grid) {
    var img = p.featured_image ? '<img src="' + esc(imgUrl(p.featured_image, 600)) + '" alt="' + esc(p.title) + '" width="600" height="' + Math.round(600 * ((p.media && p.media[0] && p.media[0].height) || 800) / ((p.media && p.media[0] && p.media[0].width) || 600)) + '" loading="lazy">' : '';
    var badge = p.available ? '' : '<span class="product-card__badge product-card__badge--soldout">' + esc(grid.getAttribute('data-sold-out')) + '</span>';
    return '<div class="product-card"><div class="product-card__media"><a class="product-card__link" href="' + esc(p.url) + '" aria-label="' + esc(p.title) + '">' + img + '</a>' + badge +
      '<button type="button" class="product-card__wishlist is-active" data-wishlist="' + esc(p.handle) + '" aria-pressed="true" aria-label="' + esc(p.title) + '">' + (document.querySelector('.product-card__wishlist svg') ? '' : '&hearts;') + '</button></div>' +
      '<div class="product-card__info"><a class="product-card__title-link" href="' + esc(p.url) + '"><h3 class="product-card__title">' + esc(p.title) + '</h3></a>' +
      '<div class="product-card__price"><span class="product-card__price--sale">' + esc(formatMoney(p.price)) + '</span>' +
      (p.compare_at_price > p.price ? ' <s class="product-card__price--compare">' + esc(formatMoney(p.compare_at_price)) + '</s>' : '') + '</div></div></div>';
  }
  function initWishlistPage(root, force) {
    var grid = $('[data-wishlist-grid]', root === document ? document : root) || (root.matches && root.matches('[data-wishlist-grid]') ? root : null);
    if (!grid || (grid.__init && !force)) return;
    grid.__init = true;
    var handles = getW();
    if (!handles.length) { grid.innerHTML = '<p class="empty-state">' + esc(grid.getAttribute('data-empty')) + '</p>'; return; }
    grid.innerHTML = '<p class="empty-state">' + esc(grid.getAttribute('data-loading')) + '</p>';
    var base = R.root || '/';
    Promise.all(handles.map(function (h) {
      return fetch(base + 'products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (list) {
      list = list.filter(Boolean);
      if (!list.length) { grid.innerHTML = '<p class="empty-state">' + esc(grid.getAttribute('data-empty')) + '</p>'; return; }
      grid.innerHTML = list.map(function (p) { return wishlistCard(p, grid); }).join('');
      // heart icon: clone from page if available
      var tpl = document.querySelector('.product-card__wishlist svg');
      if (tpl) $$('.product-card__wishlist', grid).forEach(function (b) { if (!b.querySelector('svg')) b.appendChild(tpl.cloneNode(true)); });
    });
  }

  /* ---------- Cart ---------- */
  var cartDrawer = document.getElementById('CartDrawer');
  var cartState = null;

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
  }
  function updateCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }
  function cartAttr(name) { return cartDrawer ? cartDrawer.getAttribute('data-' + name) : ''; }

  function renderShipping(cart) {
    var box = document.getElementById('CartShipping');
    if (!box || cartAttr('free-shipping') !== 'true') return;
    var threshold = Math.round((parseInt(cartAttr('threshold'), 10) || 0) * currencyRate());
    if (!threshold || !cart.items.length) { box.hidden = true; return; }
    box.hidden = false;
    var remaining = threshold - cart.total_price;
    var pct = Math.max(0, Math.min(100, (cart.total_price / threshold) * 100));
    var text = remaining > 0 ? cartAttr('text-away').replace('{{ amount }}', formatMoney(remaining)) : cartAttr('text-unlocked');
    document.getElementById('CartShippingText').textContent = text;
    document.getElementById('CartShippingBar').style.width = pct + '%';
    box.classList.toggle('is-complete', remaining <= 0);
  }

  function renderUpsell(cart) {
    var box = document.getElementById('CartUpsell');
    if (!box || cartAttr('upsell') !== 'true') return;
    if (!cart.items.length) { box.hidden = true; box.innerHTML = ''; return; }
    var pid = cart.items[0].product_id;
    if (box.__pid === pid && box.innerHTML) return;
    box.__pid = pid;
    fetch((R.root || '/') + 'recommendations/products.json?product_id=' + pid + '&limit=4&intent=related')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var inCart = cart.items.map(function (i) { return i.product_id; });
        var list = (d.products || []).filter(function (p) { return inCart.indexOf(p.id) === -1 && p.available; }).slice(0, 3);
        if (!list.length) { box.hidden = true; return; }
        box.hidden = false;
        box.innerHTML = '<h3 class="cart-drawer__upsell-title">' + esc(cartAttr('text-upsell')) + '</h3><ul class="cart-upsell" role="list">' + list.map(function (p) {
          var v = p.variants[0];
          var single = p.variants.length === 1;
          return '<li class="cart-upsell__item"><a href="' + esc(p.url) + '">' + (p.featured_image ? '<img src="' + esc(imgUrl(p.featured_image, 160)) + '" alt="" width="64" height="80" loading="lazy">' : '') + '</a>' +
            '<div><a class="cart-upsell__title" href="' + esc(p.url) + '">' + esc(p.title) + '</a><div>' + esc(formatMoney(p.price)) + '</div></div>' +
            (single ? '<button type="button" class="btn btn--outline btn--small" data-upsell-add="' + v.id + '">' + esc(cartAttr('text-add')) + '</button>' : '<a class="btn btn--outline btn--small" href="' + esc(p.url) + '">' + esc(S.viewDetails || '') + '</a>') + '</li>';
        }).join('') + '</ul>';
      }).catch(function () { box.hidden = true; });
  }

  function renderCart(cart) {
    cartState = cart;
    updateCount(cart.item_count);
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
    var wrap = document.getElementById('CartItems');
    if (!wrap) return;
    if (!cart.items.length) {
      wrap.innerHTML = '<div class="empty-state cart-empty"><p>' + esc(cartAttr('text-empty')) + '</p></div>';
    } else {
      wrap.innerHTML = '<ul class="cart-lines" role="list">' + cart.items.map(function (it, idx) {
        var line = idx + 1;
        var opts = (it.options_with_values || []).filter(function () { return !it.product_has_only_default_variant; })
          .map(function (o) { return '<div class="cart-item__variant">' + esc(o.name) + ': ' + esc(o.value) + '</div>'; }).join('');
        if (it.selling_plan_allocation && it.selling_plan_allocation.selling_plan) opts += '<div class="cart-item__variant">' + esc(it.selling_plan_allocation.selling_plan.name) + '</div>';
        if (it.unit_price_measurement) opts += '<div class="cart-item__variant">' + esc(formatMoney(it.unit_price)) + ' / ' + esc(it.unit_price_measurement.reference_value) + esc(it.unit_price_measurement.reference_unit) + '</div>';
        var discounts = (it.line_level_discount_allocations || []).map(function (a) {
          return '<div class="cart-item__discount">' + esc(a.discount_application.title) + ' (-' + esc(formatMoney(a.amount)) + ')</div>';
        }).join('');
        var price = it.original_line_price !== it.final_line_price ? '<s>' + esc(formatMoney(it.original_line_price)) + '</s> ' : '';
        return '<li class="cart-item" data-line="' + line + '">' +
          '<a class="cart-item__media" href="' + esc(it.url) + '">' + (it.image ? '<img src="' + esc(imgUrl(it.image, 200)) + '" alt="' + esc(it.featured_image && it.featured_image.alt || it.product_title) + '" width="100" height="125" loading="lazy">' : '') + '</a>' +
          '<div class="cart-item__info"><h3 class="cart-item__title"><a href="' + esc(it.url) + '">' + esc(it.product_title) + '</a></h3>' + opts + discounts +
          '<div class="cart-item__row"><div class="qty"><button type="button" data-cart-line-qty="-1" aria-label="' + esc(cartAttr('text-decrease')) + '">&minus;</button>' +
          '<input type="text" value="' + it.quantity + '" inputmode="numeric" pattern="[0-9]*" aria-label="' + esc(it.product_title) + '" data-cart-line-input>' +
          '<button type="button" data-cart-line-qty="1" aria-label="' + esc(cartAttr('text-increase')) + '">+</button></div>' +
          '<div class="cart-item__price">' + price + esc(formatMoney(it.final_line_price)) + '</div></div>' +
          '<button type="button" class="cart-item__remove" data-cart-remove="' + line + '">' + esc(cartAttr('text-remove')) + '</button></div></li>';
      }).join('') + '</ul>';
    }
    var sub = document.getElementById('CartSubtotal');
    if (sub) sub.textContent = formatMoney(cart.total_price);
    var foot = document.getElementById('CartFoot');
    if (foot) foot.hidden = !cart.items.length;
    var note = document.getElementById('CartNote');
    if (note && document.activeElement !== note) note.value = cart.note || '';
    renderShipping(cart);
    renderUpsell(cart);
  }

  function refreshCart() {
    return fetch(R.cartJson || '/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { renderCart(c); return c; })
      .catch(function () { return null; });
  }
  function changeLine(line, qty) {
    var wrap = document.getElementById('CartItems');
    if (wrap) wrap.classList.add('is-loading');
    return post(R.cartChange || '/cart/change.js', { line: line, quantity: qty })
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .finally(function () { if (wrap) wrap.classList.remove('is-loading'); });
  }

  function afterAdd() {
    if (cartDrawer) { return refreshCart().then(function () { openDrawer('CartDrawer'); }); }
    window.location.href = R.cart || '/cart';
    return Promise.resolve();
  }
  function addToCart(body) {
    return post(R.cartAdd || '/cart/add.js', body).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || S.error);
        return j;
      });
    });
  }

  document.addEventListener('click', function (e) {
    var qty = e.target.closest('[data-cart-line-qty]');
    if (qty) {
      var item = qty.closest('.cart-item');
      var input = $('[data-cart-line-input]', item);
      var next = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(qty.getAttribute('data-cart-line-qty'), 10));
      changeLine(parseInt(item.getAttribute('data-line'), 10), next);
      return;
    }
    var rem = e.target.closest('[data-cart-remove]');
    if (rem) { changeLine(parseInt(rem.getAttribute('data-cart-remove'), 10), 0); return; }
    var up = e.target.closest('[data-upsell-add]');
    if (up) {
      up.disabled = true;
      addToCart({ id: parseInt(up.getAttribute('data-upsell-add'), 10), quantity: 1 }).then(refreshCart).finally(function () { up.disabled = false; });
      return;
    }
    var qa = e.target.closest('[data-quick-add]');
    if (qa) {
      e.preventDefault();
      qa.disabled = true;
      addToCart({ id: parseInt(qa.getAttribute('data-quick-add'), 10), quantity: 1 })
        .then(afterAdd)
        .catch(function () { window.location.href = qa.getAttribute('data-product-url') || R.cart || '/cart'; })
        .finally(function () { qa.disabled = false; });
    }
  });
  document.addEventListener('change', function (e) {
    var inp = e.target.closest('[data-cart-line-input]');
    if (inp) {
      var item = inp.closest('.cart-item');
      changeLine(parseInt(item.getAttribute('data-line'), 10), Math.max(0, parseInt(inp.value, 10) || 0));
    }
    if (e.target.id === 'CartNote') {
      post(R.cartUpdate || '/cart/update.js', { note: e.target.value });
    }
  });
  if (cartDrawer) refreshCart();

  /* ---------- App compatibility: keep the cart drawer in sync with app-driven changes ---------- */
  window.theme = window.theme || {};
  window.theme.cart = { refresh: refreshCart, open: function () { return refreshCart().then(function () { if (cartDrawer) openDrawer('CartDrawer'); }); } };
  ['cart:refresh', 'cart:change', 'cart:build', 'theme:cart:refresh'].forEach(function (name) {
    document.addEventListener(name, function () { refreshCart(); });
  });
  document.addEventListener('cart:open', function () { window.theme.cart.open(); });
  (function watchCartRequests() {
    if (!window.fetch || window.__themeFetchWatched) return;
    window.__themeFetchWatched = true;
    var native = window.fetch, timer;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = native.apply(this, arguments);
      if (/\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/.test(url)) {
        p.then(function () { clearTimeout(timer); timer = setTimeout(refreshCart, 200); }).catch(function () { /* noop */ });
      }
      return p;
    };
  })();

  /* ---------- Cart page free-shipping message (currency aware) ---------- */
  function initCartPageShipping(root) {
    $$('[data-cart-page-shipping]', root).forEach(function (box) {
      var threshold = Math.round((parseInt(box.getAttribute('data-threshold'), 10) || 0) * currencyRate());
      var total = parseInt(box.getAttribute('data-total'), 10) || 0;
      var remaining = threshold - total;
      var p = box.querySelector('p');
      if (!p || !threshold) return;
      p.textContent = remaining > 0 ? box.getAttribute('data-text-away').replace('{{ amount }}', formatMoney(remaining)) : box.getAttribute('data-text-unlocked');
      box.hidden = false;
    });
  }

  /* ---------- Cart page (quantity buttons auto-update) ---------- */
  function initCartPage(root) {
    $$('form[action$="/cart"]', root).forEach(function (form) {
      if (form.__init || !$('[data-cart-page-input]', form)) return;
      form.__init = true;
      var submitUpdate = debounce(function () {
        var btn = $('[name="update"]', form);
        if (form.requestSubmit && btn) form.requestSubmit(btn); else form.submit();
      }, 700);
      form.addEventListener('click', function (e) {
        var b = e.target.closest('[data-cart-page-qty]');
        if (!b) return;
        var input = $('[data-cart-page-input]', b.parentNode);
        input.value = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(b.getAttribute('data-cart-page-qty'), 10));
        submitUpdate();
      });
      form.addEventListener('change', function (e) {
        if (e.target.matches('[data-cart-page-input]')) submitUpdate();
      });
    });
  }

  /* ---------- Product sections ---------- */
  function initProductSections(root) {
    $$('[data-product-section]', root).forEach(function (sec) {
      if (sec.__init) return;
      sec.__init = true;
      var sid = sec.getAttribute('data-product-section');
      var jsonEl = document.getElementById('ProductJson-' + sid);
      if (!jsonEl) return;
      var product;
      try { product = JSON.parse(jsonEl.textContent); } catch (e) { return; }
      rvTrack(product.id);
      var form = $('form[data-product-form]', sec);
      var idInput = form && $('[data-variant-id]', form);
      var addBtn = form && $('[data-add-to-bag]', form);
      var errorEl = form && $('[data-form-error]', form);
      var sticky = document.querySelector('[data-sticky-atc]');

      /* gallery */
      var track = $('[data-gallery-track]', sec);
      var slides = track ? $$('.product-gallery__slide', track) : [];
      var lightbox = document.getElementById('Lightbox-' + sid);
      var dots = $$('[data-gallery-dots] button', sec);
      var thumbs = $$('.product-gallery__thumbs button', sec);
      function cur() { return track ? Math.round(Math.abs(track.scrollLeft) / track.clientWidth) : 0; }
      function goTo(i) {
        if (!track || !slides.length) return;
        i = (i + slides.length) % slides.length;
        track.scrollTo({ left: (document.documentElement.dir === 'rtl' ? -1 : 1) * i * track.clientWidth, behavior: reduceMotion ? 'auto' : 'smooth' });
      }
      function syncGallery() {
        var i = cur();
        dots.forEach(function (d, di) { d.classList.toggle('is-active', di === i); });
        thumbs.forEach(function (t, ti) { t.classList.toggle('is-active', ti === i); });
      }
      if (track) {
        track.addEventListener('scroll', debounce(syncGallery, 80), { passive: true });
        track.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowLeft') goTo(cur() - 1);
          if (e.key === 'ArrowRight') goTo(cur() + 1);
        });
        var gp = $('[data-gallery-prev]', sec), gn = $('[data-gallery-next]', sec);
        if (gp) gp.addEventListener('click', function () { goTo(cur() - 1); });
        if (gn) gn.addEventListener('click', function () { goTo(cur() + 1); });
        dots.forEach(function (d) { d.addEventListener('click', function () { goTo(parseInt(d.getAttribute('data-dot'), 10)); }); });
        thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(parseInt(t.getAttribute('data-index'), 10)); }); });
      }
      function showImage(id) {
        var idx = slides.findIndex(function (s) { return s.getAttribute('data-media-id') == id; });
        if (idx > -1) goTo(idx);
      }

      /* image lightbox */
      if (track && lightbox) {
        track.addEventListener('click', function (e) {
          var img = e.target.closest('img[data-zoom-src]');
          if (!img) return;
          var big = $('[data-lightbox-img]', lightbox);
          big.src = img.getAttribute('data-zoom-src');
          big.alt = img.alt;
          openModal(lightbox.id, img);
        });
      }

      /* quantity */
      var qtyInput = $('[data-qty-input]', sec);
      $$('[data-qty]', sec).forEach(function (b) {
        b.addEventListener('click', function () {
          if (!qtyInput) return;
          qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + parseInt(b.getAttribute('data-qty'), 10));
        });
      });
      if (qtyInput) qtyInput.addEventListener('change', function () { qtyInput.value = Math.max(1, parseInt(qtyInput.value, 10) || 1); });

      /* variant selection */
      function selectedOptions() {
        var out = [];
        $$('[data-option-index]', sec).forEach(function (fs) {
          var c = $('input:checked', fs);
          out[parseInt(fs.getAttribute('data-option-index'), 10)] = c ? c.value : null;
        });
        return out;
      }
      function findVariant(opts) {
        return product.variants.filter(function (v) {
          return opts.every(function (o, i) { return o === null || o === undefined || v.options[i] === o; });
        })[0] || null;
      }
      function markAvailability() {
        var opts = selectedOptions();
        $$('[data-option-index]', sec).forEach(function (fs) {
          var pos = parseInt(fs.getAttribute('data-option-index'), 10);
          $$('input', fs).forEach(function (inp) {
            var test = opts.slice();
            test[pos] = inp.value;
            var v = findVariant(test);
            var label = $('label[for="' + inp.id + '"]', fs);
            if (label) label.classList.toggle('is-unavailable', !v || !v.available);
          });
        });
      }
      function setButton(variant) {
        if (!addBtn) return;
        var span = $('span', addBtn);
        var text, disabled;
        if (!variant) { text = addBtn.getAttribute('data-unavailable-text'); disabled = true; }
        else if (!variant.available) { text = addBtn.getAttribute('data-sold-text'); disabled = true; }
        else { text = addBtn.getAttribute('data-add-text'); disabled = false; }
        addBtn.disabled = disabled;
        if (span) span.textContent = text;
        if (sticky) {
          var sb = $('[data-sticky-add]', sticky);
          if (sb) { sb.disabled = disabled; sb.textContent = text; }
        }
      }
      function swapFromServer(variant) {
        if (!variant) return;
        var url = window.location.pathname + '?variant=' + variant.id + '&section_id=' + encodeURIComponent(sid);
        fetch(url).then(function (r) { return r.text(); }).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          ['[data-product-price]', '[data-inventory]', '[data-sticky-price]', '[data-selling-plans]'].forEach(function (sel) {
            var fresh = $(sel, doc), old = $(sel, document);
            if (fresh && old) old.innerHTML = fresh.innerHTML;
            else if (!fresh && old && sel === '[data-inventory]') old.innerHTML = '';
          });
        }).catch(function () { /* price stays as is */ });
      }
      function onVariantChange() {
        var opts = selectedOptions();
        $$('[data-option-selected]', sec).forEach(function (el) {
          var i = parseInt(el.getAttribute('data-option-selected'), 10);
          if (opts[i]) el.textContent = opts[i];
        });
        var variant = findVariant(opts);
        if (errorEl) errorEl.hidden = true;
        setButton(variant);
        markAvailability();
        if (variant) {
          if (idInput) idInput.value = variant.id;
          var u = new URL(window.location.href);
          u.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', u.toString());
          if (variant.featured_media && variant.featured_media.id) showImage(variant.featured_media.id);
          swapFromServer(variant);
        }
      }
      $$('[data-option-index] input', sec).forEach(function (inp) { inp.addEventListener('change', onVariantChange); });
      markAvailability();

      /* add to cart */
      function submitForm(e) {
        if (e) e.preventDefault();
        if (!form || !addBtn || addBtn.disabled) return;
        var fd = new FormData(form);
        var body = { id: parseInt(fd.get('id'), 10), quantity: parseInt(fd.get('quantity') || '1', 10) || 1 };
        if (fd.get('selling_plan')) body.selling_plan = parseInt(fd.get('selling_plan'), 10);
        var props = {};
        fd.forEach(function (val, key) {
          var m = key.match(/^properties\[(.+)\]$/);
          if (m) props[m[1]] = val;
        });
        if (Object.keys(props).length) body.properties = props;
        addBtn.disabled = true;
        addBtn.classList.add('is-loading');
        if (errorEl) errorEl.hidden = true;
        addToCart(body).then(afterAdd).catch(function (err) {
          if (errorEl) { errorEl.textContent = err.message || S.error; errorEl.hidden = false; }
        }).finally(function () {
          addBtn.classList.remove('is-loading');
          setButton(findVariant(selectedOptions()) || product.variants[0]);
        });
      }
      if (form) form.addEventListener('submit', submitForm);

      /* sticky add-to-cart bar */
      if (sticky && addBtn && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          var gone = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
          sticky.hidden = !gone;
          sticky.classList.toggle('is-visible', gone);
        });
        io.observe(addBtn);
        var sa = $('[data-sticky-add]', sticky);
        if (sa) sa.addEventListener('click', function () { submitForm(); });
      }

      /* share */
      var share = $('[data-share]', sec);
      if (share) {
        share.addEventListener('click', function () {
          var data = { title: share.getAttribute('data-title'), url: share.getAttribute('data-url') };
          if (navigator.share) { navigator.share(data).catch(function () { /* cancelled */ }); return; }
          var done = $('[data-share-done]', sec);
          var show = function () { if (done) { done.hidden = false; setTimeout(function () { done.hidden = true; }, 2000); } };
          if (navigator.clipboard) navigator.clipboard.writeText(data.url).then(show);
        });
      }
    });
  }

  /* product recommendations */
  if (window.customElements && !customElements.get('product-recommendations')) {
    customElements.define('product-recommendations', class extends HTMLElement {
      connectedCallback() {
        var self = this, url = this.getAttribute('data-url');
        if (!url || this.querySelector('.carousel')) return;
        fetch(url).then(function (r) { return r.text(); }).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('product-recommendations');
          if (fresh && fresh.innerHTML.trim().length) {
            self.innerHTML = fresh.innerHTML;
            syncW(self);
            initReveal(self);
          }
        }).catch(function () { /* noop */ });
      }
    });
  }


  /* ---------- Recently viewed ---------- */
  var RV_KEY = 'theme_recent';
  function rvGet() { try { return JSON.parse(store(RV_KEY) || '[]'); } catch (e) { return []; } }
  function rvTrack(id) {
    var list = rvGet().filter(function (x) { return String(x) !== String(id); });
    list.unshift(id);
    store(RV_KEY, JSON.stringify(list.slice(0, 20)));
  }
  function initRecentlyViewed(root) {
    $$('[data-recently-viewed]', root).forEach(function (sec) {
      if (sec.__init) return;
      sec.__init = true;
      var exclude = sec.getAttribute('data-exclude');
      var limit = parseInt(sec.getAttribute('data-limit'), 10) || 5;
      var ids = rvGet().filter(function (x) { return String(x) !== String(exclude); }).slice(0, limit);
      if (!ids.length) return;
      var q = ids.map(function (id) { return 'id:' + id; }).join(' OR ');
      var url = (sec.getAttribute('data-url') || '/search') + '?section_id=' + encodeURIComponent(sec.getAttribute('data-section-id')) + '&type=product&q=' + encodeURIComponent(q);
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-recently-viewed-list]');
        var list = $('[data-recently-viewed-list]', sec);
        if (fresh && list && fresh.children.length) {
          list.innerHTML = fresh.innerHTML;
          sec.hidden = false;
          syncW(sec);
        }
      }).catch(function () { /* stays hidden */ });
    });
  }

  /* ---------- Quick view ---------- */
  var qvContent = document.getElementById('QuickViewContent');
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-quick-view]');
    if (!b || !qvContent) return;
    e.preventDefault();
    qvContent.innerHTML = '<p class="quick-view__loading">' + esc(S.loading) + '</p>';
    openModal('QuickViewModal', b);
    fetch((R.root || '/') + 'products/' + encodeURIComponent(b.getAttribute('data-quick-view')) + '.js')
      .then(function (r) { if (!r.ok) throw new Error('x'); return r.json(); })
      .then(function (prod) {
        var img = (prod.featured_image || (prod.images && prod.images[0])) || '';
        var multi = !(prod.variants.length === 1 && prod.options.length === 1 && prod.options[0].name === 'Title');
        var opts = multi ? prod.options.map(function (opt, idx) {
          return '<fieldset class="product-option" data-qv-option="' + idx + '"><legend class="variant-label"><span>' + esc(opt.name) + '</span></legend><div class="variant-pills">' +
            opt.values.map(function (v, i) {
              var id = 'qv-' + idx + '-' + i;
              return '<input type="radio" class="variant-radio" name="qv-opt-' + idx + '" id="' + id + '" value="' + esc(v) + '"' + (i === 0 ? ' checked' : '') + '><label class="variant-pill" for="' + id + '">' + esc(v) + '</label>';
            }).join('') + '</div></fieldset>';
        }).join('') : '';
        qvContent.innerHTML = '<div class="qv-grid"><div class="qv-media">' + (img ? '<img src="' + esc(imgUrl(img, 900)) + '" alt="' + esc(prod.title) + '" width="900" height="1125">' : '') + '</div>' +
          '<div class="qv-info"><h2 class="modal__title">' + esc(prod.title) + '</h2><div class="product-info__price" data-qv-price>' + esc(formatMoney(prod.price)) + '</div>' + opts +
          '<button type="button" class="btn btn--primary btn--block" data-qv-add' + (prod.available ? '' : ' disabled') + '>' + esc(prod.available ? S.addToBag : S.soldOut) + '</button>' +
          '<p class="product-form__error" role="alert" data-qv-error hidden></p>' +
          '<a class="qv-link" href="' + esc(prod.url) + '">' + esc(S.viewDetails) + '</a></div></div>';
        function current() {
          var sel = $$('[data-qv-option]', qvContent).map(function (g) { var c = $('input:checked', g); return c ? c.value : null; });
          return prod.variants.filter(function (v) { return sel.every(function (o, i) { return o === null || v.options[i] === o; }); })[0] || prod.variants[0];
        }
        var add = $('[data-qv-add]', qvContent), priceEl = $('[data-qv-price]', qvContent), errEl = $('[data-qv-error]', qvContent);
        function refresh() {
          var v = current();
          priceEl.textContent = formatMoney(v.price);
          add.disabled = !v.available;
          add.textContent = v.available ? S.addToBag : S.soldOut;
        }
        $$('[data-qv-option] input', qvContent).forEach(function (i) { i.addEventListener('change', refresh); });
        add.addEventListener('click', function () {
          var v = current();
          if (!v || !v.available) return;
          add.disabled = true;
          errEl.hidden = true;
          addToCart({ id: v.id, quantity: 1 }).then(function () { closeModals(); return afterAdd(); }).catch(function (err) {
            errEl.textContent = err.message || S.error;
            errEl.hidden = false;
          }).finally(function () { add.disabled = false; });
        });
      })
      .catch(function () { qvContent.innerHTML = '<p class="quick-view__loading">' + esc(S.error) + '</p>'; });
  });

  /* ---------- Search (predictive) ---------- */
  var searchInput = document.getElementById('SearchInput');
  var searchResults = document.getElementById('SearchResults');
  var searchDrawer = document.getElementById('SearchDrawer');
  if (searchInput && searchResults && searchDrawer && searchDrawer.getAttribute('data-predictive') !== 'false') {
    var withArticles = searchDrawer.getAttribute('data-articles') === 'true';
    var run = debounce(function () {
      var q = searchInput.value.trim();
      if (q.length < 2) { searchResults.innerHTML = ''; return; }
      var types = 'product' + (withArticles ? ',article,page' : '');
      var url = (R.suggest || '/search/suggest.json') + '?q=' + encodeURIComponent(q) + '&resources[type]=' + types + '&resources[limit]=4&resources[options][unavailable_products]=last';
      fetch(url).then(function (r) { return r.json(); }).then(function (d) {
        var res = (d.resources && d.resources.results) || {};
        var out = '';
        var products = res.products || [];
        if (products.length) {
          out += '<h3 class="search-results__title">' + esc(searchDrawer.getAttribute('data-products-label')) + '</h3><ul class="search-results__products" role="list">' + products.map(function (p) {
            return '<li><a class="search-item" href="' + esc(p.url) + '">' + (p.image ? '<img src="' + esc(imgUrl(p.image, 200)) + '" alt="" width="64" height="80" loading="lazy">' : '') +
              '<span class="search-item__title">' + esc(p.title) + '</span>' + (p.price ? '<span class="search-item__type">' + esc(formatMoney(String(p.price).replace('.', ''))) + '</span>' : '') + '</a></li>';
          }).join('') + '</ul>';
        }
        [['articles', 'data-articles-label'], ['pages', 'data-pages-label']].forEach(function (g) {
          var list = res[g[0]] || [];
          if (!list.length) return;
          out += '<h3 class="search-results__title">' + esc(searchDrawer.getAttribute(g[1])) + '</h3><ul class="search-results__list" role="list">' + list.map(function (a) {
            return '<li><a class="search-item" href="' + esc(a.url) + '"><span class="search-item__title">' + esc(a.title) + '</span></a></li>';
          }).join('') + '</ul>';
        });
        if (!out) out = '<p class="empty-state">' + esc((S.noResults || '').replace('__TERMS__', q)) + '</p>';
        else out += '<a class="btn btn--outline search-results__all" href="' + esc((R.search || '/search') + '?q=' + encodeURIComponent(q)) + '">' + esc(S.viewAll) + '</a>';
        searchResults.innerHTML = out;
      }).catch(function () { /* noop */ });
    }, 250);
    searchInput.addEventListener('input', run);
  }

  /* ---------- Collection facets ---------- */
  function initFacets(root) {
    $$('[data-facet-form]', root).forEach(function (form) {
      if (form.__init) return;
      form.__init = true;
      var sort = $('[data-facet-sort]', form);
      if (sort) sort.addEventListener('change', function () { form.submit(); });
      form.addEventListener('submit', function () {
        $$('[data-facet-price]', form).forEach(function (i) { if (i.value === '') i.disabled = true; });
      });
    });
  }

  /* ---------- Newsletter (real Shopify customer form, enhanced) ---------- */
  var POPUP_KEY = 'theme_popup_seen';
  function initNewsletters(root) {
    $$('form.js-newsletter', root).forEach(function (f) {
      if (f.__init) return;
      f.__init = true;
      f.addEventListener('submit', function (e) {
        if (!window.fetch) return;
        e.preventDefault();
        var field = $('.newsletter-form__field', f);
        var ok = $('[data-newsletter-success]', f);
        var errs = $$('.newsletter-form__msg--error', f);
        errs.forEach(function (x) { x.remove(); });
        var btn = $('button[type="submit"]', f);
        if (btn) btn.disabled = true;
        fetch(f.action, { method: 'POST', body: new FormData(f), headers: { Accept: 'text/html' } })
          .then(function (r) {
            var url = r.url || '';
            if (url.indexOf('/challenge') > -1) { f.submit(); return; }
            if (url.indexOf('customer_posted=true') > -1) {
              if (field) field.hidden = true;
              if (ok) ok.hidden = false;
              store(POPUP_KEY, '1');
              if (f.closest('#PromoPopup')) setTimeout(dismissPopup, 2200);
            } else {
              var p = document.createElement('p');
              p.className = 'newsletter-form__msg newsletter-form__msg--error';
              p.setAttribute('role', 'alert');
              p.textContent = S.error;
              f.appendChild(p);
            }
          })
          .catch(function () { f.submit(); })
          .finally(function () { if (btn) btn.disabled = false; });
      });
    });
  }

  /* ---------- Promo popup ---------- */
  var popup = document.getElementById('PromoPopup');
  function dismissPopup() {
    if (!popup) return;
    popup.classList.remove('is-open');
    popup.hidden = true;
    store(POPUP_KEY, '1');
    if (!openDrawers().length) lockScroll(false);
  }
  function showPopup() {
    if (!popup) return;
    popup.hidden = false;
    requestAnimationFrame(function () { popup.classList.add('is-open'); });
    lockScroll(true);
    var f = $(focusable, popup);
    if (f) setTimeout(function () { f.focus(); }, 60);
  }
  if (popup) {
    popup.addEventListener('click', function (e) {
      if (e.target.closest('[data-popup-close]') || e.target === popup) dismissPopup();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && popup.classList.contains('is-open')) dismissPopup(); });
    var posted = /[?&]customer_posted=true/.test(window.location.search);
    if (posted) store(POPUP_KEY, '1');
    if (!store(POPUP_KEY) && !T.designMode) {
      var delay = (parseInt(popup.getAttribute('data-delay') || '5', 10) || 5) * 1000;
      setTimeout(function () { if (!store(POPUP_KEY)) showPopup(); }, delay);
    }
    document.addEventListener('shopify:section:select', function (e) { if (popup.contains(e.target) || e.target.contains(popup)) showPopup(); });
    document.addEventListener('shopify:section:deselect', function () { if (popup.classList.contains('is-open')) { popup.classList.remove('is-open'); popup.hidden = true; lockScroll(false); } });
  }


  /* ---------- Delivery estimate (calculated in the browser from today's date) ---------- */
  function initDelivery(root) {
    $$('[data-delivery]', root).forEach(function (el) {
      if (el.__init) return;
      el.__init = true;
      var min = parseInt(el.getAttribute('data-min'), 10) || 3, max = parseInt(el.getAttribute('data-max'), 10) || 5;
      var skip = el.getAttribute('data-skip-weekends') === 'true';
      function add(days) {
        var d = new Date();
        var n = 0;
        while (n < days) { d.setDate(d.getDate() + 1); if (!skip || (d.getDay() !== 0 && d.getDay() !== 6)) n++; }
        return d;
      }
      var fmt = new Intl.DateTimeFormat(document.documentElement.lang || undefined, { weekday: 'short', day: 'numeric', month: 'short' });
      var range = fmt.format(add(min)) + ' - ' + fmt.format(add(max));
      $('[data-delivery-text]', el).textContent = (el.getAttribute('data-label') || '{date_range}').replace('{date_range}', range);
      el.hidden = false;
    });
  }

  /* ---------- Hide header on scroll down ---------- */
  if (header && header.getAttribute('data-hide-on-scroll') === 'true') {
    var lastY = window.scrollY;
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      if (Math.abs(y - lastY) < 8) return;
      header.classList.toggle('is-hidden', y > lastY && y > 200 && !openDrawers().length);
      lastY = y;
    }, { passive: true });
  }

  /* ---------- Collection "load more" / infinite scroll ---------- */
  function initLoadMore(root) {
    $$('[data-load-more]', root).forEach(function (wrap) {
      if (wrap.__init) return;
      wrap.__init = true;
      var btn = $('button', wrap);
      var grid = document.querySelector(wrap.getAttribute('data-target'));
      var infinite = wrap.getAttribute('data-mode') === 'infinite';
      var loading = false;
      function load() {
        var url = wrap.getAttribute('data-next-url');
        if (!url || loading || !grid) return;
        loading = true;
        btn.disabled = true;
        fetch(url).then(function (r) { return r.text(); }).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector(wrap.getAttribute('data-target'));
          if (fresh) { Array.prototype.slice.call(fresh.children).forEach(function (c) { grid.appendChild(document.importNode(c, true)); }); syncW(grid); }
          var next = doc.querySelector('[data-load-more]');
          if (next && next.getAttribute('data-next-url')) { wrap.setAttribute('data-next-url', next.getAttribute('data-next-url')); }
          else { wrap.hidden = true; if (io) io.disconnect(); }
        }).catch(function () { /* keep button */ }).finally(function () { loading = false; btn.disabled = false; });
      }
      btn.addEventListener('click', load);
      var io = null;
      if (infinite && 'IntersectionObserver' in window) {
        io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) load(); }, { rootMargin: '400px' });
        io.observe(wrap);
      }
    });
  }

  /* ---------- Boot ---------- */
  initAll(document);
})();
